import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  ClickableTile,
  InlineNotification,
  NotificationActionButton
} from 'carbon-components-react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { selectSupportError } from 'redux/user/selector';
import { clearSupportForm } from 'redux/user/actions';

const SupportReqSuccess: React.FC<Props> = (props) => {
  const { unauthenticated } = props;
  const isSupportSubmitError = useSelector(selectSupportError);
  const dispatch: any = useDispatch();
  const history = useHistory();
  return (
    <InlineNotification
      className={`support-request--success success-notification ${
        unauthenticated ? ' unathenticated' : ''
      }`}
      kind={isSupportSubmitError ? 'error' : 'success'}
      lowContrast
      actions={
        <NotificationActionButton
          className="action--button"
          onClick={() => history.push(`https://help.byda.com.au/`)}
        >
          <ClickableTile
            href="https://help.byda.com.au/"
            target="_blank"
            className="tile-clickable"
          >
            Solutions to common problems
          </ClickableTile>
        </NotificationActionButton>
      }
      onCloseButtonClick={() => {
        dispatch(clearSupportForm());
      }}
      iconDescription="Close notification panel"
      subtitle={
        isSupportSubmitError
          ? 'Problem submitting support form, please try again later.'
          : 'We will get back to you soon. In the meantime, you can check out our FAQs.'
      }
      title={
        isSupportSubmitError
          ? 'Error.'
          : 'Thanks for submitting your support request.'
      }
    />
  );
};

const propTypes = {
  unauthenticated: PropTypes.bool
};

type Props = PropTypes.InferProps<typeof propTypes>;

SupportReqSuccess.defaultProps = {
  unauthenticated: false
};

SupportReqSuccess.displayName = 'ContactSupportModal';
export default SupportReqSuccess;
